// Simple store bridge to avoid direct imports that create circular dependencies
let storeRef = null;

export function provideStore(store) {
  storeRef = store;
}

export function getStore() {
  return storeRef;
}
